module.exports = __webpack_public_path__ + "static/media/Enmascarar grupo 228.73a92044.svg";